import { Assert } from "../Assert";
import { ObjectHelper } from "../Helpers/ObjectHelper";
import { PropertyChange } from "../PropertyChange";
import { Property, PropertyString } from "../RadObject";
import { Evaluator } from "../Server/DotNet/SeriouslyRAD.Framework/Evaluation/Evaluator";
import { EvaluatorPropertyValues, IEvaluator } from "../Server/DotNet/SeriouslyRAD.Framework/Evaluation/IEvaluator";
import { NAMESPACE } from "./_Namespace";

export type MethodEvaluatorPropertyValues =
    EvaluatorPropertyValues
    & {
        methodPath: string;
    };

export type MethodEvaluatorProperties = {
    [name in keyof MethodEvaluatorPropertyValues]: Property<MethodEvaluatorPropertyValues[name]>
};

export interface IMethodEvaluator extends IEvaluator, MethodEvaluatorProperties
{
}

export class MethodEvaluator extends Evaluator<MethodEvaluatorPropertyValues> implements IMethodEvaluator
{
    public static override classNamespace = NAMESPACE + "MethodEvaluator";
    public static override className = "MethodEvaluator";

    // #region Properties

    public methodPath!: PropertyString;

    // #endregion

    // #region Protected Methods

    protected _methodPathChanged(change: PropertyChange<string>)
    {
        /* Intentionally empty */
    }

    // #endregion

    // #region Overrides

    protected override __initializeProperties(propertyValues: MethodEvaluatorPropertyValues)
    {
        super.__initializeProperties(propertyValues);

        this.methodPath = new PropertyString(this, propertyValues.methodPath, this._methodPathChanged);
    }

    public override clone(): this
    {
        const
            evaluator = super.clone() as this;

        evaluator.methodPath.set(this.methodPath.get());

        return evaluator;
    }
    public override evaluate()
    {
        const
            methodPath = this.methodPath.get();

        Assert.isNotNullOrUndefined(methodPath, "methodPath");

        const
            method = ObjectHelper.propertyValueByPathGet(window, methodPath) as (methodEvaluator: MethodEvaluator) => boolean;

        Assert.isNotNullOrUndefined(method, "method");

        const
            value = method(this);

        this.value.set(value);

        return value;
    }

    // #endregion
}
